import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFileColor from './icon-file-color.vue';

const IconFileColor = Object.assign(_IconFileColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFileColor.name, _IconFileColor);
  }
});

export default IconFileColor;
